import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardUIType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-card-item-main-view',
  templateUrl: './card-item-main-view.component.html',
  styleUrls: ['./card-item-main-view.component.scss'],
})
export class CardItemMainViewComponent {
  @Input() card: PlaylistCardShort;
  @Input() cardType: CardUIType = 'general';
  @Input() showImage = true;
  @Input() showMeta = true;
  @Input() showReviews = true;

  @Output() cardClick = new EventEmitter<PlaylistCardShort>();
}
